export default {
      id: "temperature-usage",
      viewBox: "0 0 6.347 16.921",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#temperature",
      toString: function () {
        return this.url;
      }
    }